module.exports = __webpack_public_path__ + "html/studio-header_07f26b6f259883f472a572b6f8c0d625.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/studio-header.html
// module id = 1aEF
// module chunks = 118